"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadFollowUpExpiringRo = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.LeadFollowUpExpiringRo = typebox_1.Type.Object({
    quote_total: typebox_1.Type.String(),
    /**
     * as an empty string or in yyyy-mm-dd format
     */
    last_order_date: typebox_1.Type.String(),
    first_name: typebox_1.Type.String(),
    dumpster_size: typebox_1.Type.String(),
    material: typebox_1.Type.String(),
    service_location: typebox_1.Type.String(),
    price_type: typebox_1.Type.String(),
    ton_limit: typebox_1.Type.String(),
    rental_period: typebox_1.Type.String(),
    quote_url: typebox_1.Type.String(),
    max_rental_days: typebox_1.Type.String(),
    special_material_string: typebox_1.Type.String(),
    rental_extension_fee: typebox_1.Type.String(),
});
//# sourceMappingURL=lead-follow-up-expiring-ro.js.map